import ShowCalendar from '../components/show-calendar.svelte'
export default {
	init() {},
	finalize() {
		showCalendar()
	},
}

function showCalendar() {
	let $calendar = $('#show_calendar')
	if ($calendar.length) {
		new ShowCalendar({
			target: $calendar[0],
			props: $calendar.data(),
		})
	}
}
